import { toRefs } from 'vue';

export default {
  name: 'wrappedTeleport',
  props: {
    // teleport先のID。未指定の場合はteleportタグ自体を描画しない
    destinationId: { type: String, required: false },
    // teleportを一時的に無効化する
    disabled: { type: Boolean, default: false, required: false },
    // teleportを無効化するか否か。teleport先描画までteleportを描画しない場合や、参照を切るために明示的にteleportの描画をなくす場合に指定
    noRenderTeleport: { type: Boolean, default: false, required: false },
  },

  setup(props) {
    // 親コンポーネントからのデータや関数
    const { destinationId, disabled, noRenderTeleport } = toRefs(props);

    return {
      destinationId,
      disabled,
      noRenderTeleport
    };
  }
};